import { CdkDragDrop, DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop';
import { NgForOf, NgIf } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogModule as MatDialogModule,
} from '@angular/material/legacy-dialog';
import { OrderListTableField } from 'cloud-shared-lib';

type DialogData = Readonly<OrderListTableField>[];

@Component({
  selector: 'cutting-order-table-fields-dialog',
  standalone: true,
  imports: [
    NgForOf,
    NgIf,
    MatDialogModule,
    MatIconModule,
    MatButtonModule,
    DragDropModule,
    MatCheckboxModule,
    FormsModule,
  ],
  templateUrl: './order-table-fields-dialog.component.html',
  styleUrls: ['./order-table-fields-dialog.component.scss'],
})
export class OrderTableFieldsDialogComponent {
  fields: OrderListTableField[] = [];

  constructor(@Inject(MAT_DIALOG_DATA) private dialogData: DialogData) {
    this.fields = this.dialogData ?? this.getDefaultOrderTableFields();
  }

  drop(event: CdkDragDrop<OrderListTableField[]>): void {
    moveItemInArray(this.fields, event.previousIndex, event.currentIndex);
  }

  private getDefaultOrderTableFields = (): OrderListTableField[] => {
    return [
      { name: 'name', visible: true },
      { name: 'factoryOrderId', visible: true },
      { name: 'amount', visible: true },
      { name: 'note', visible: true },
      { name: 'clientNote', visible: true },
      { name: 'statusName', visible: true },
      { name: 'dateCreate', visible: true },
      { name: 'dateEdit', visible: true },
      { name: 'plannedDateOfIssue', visible: false },
      { name: 'dateOfIssue', visible: false },
      { name: 'menu', visible: true },
    ];
  };
}
